module.exports = __webpack_public_path__ + "static/media/5DPO19.8e5d838c.jpg";